import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import { getChartCostSummaryDetails } from 'src/services/shouldCostAIBased.services'

const initialState = {
  summaryChartLoader: false,
  summaryChartError: '',
  summaryChart_state: [],
}

export const summaryChartSlice = createSlice({
  name: 'summaryChart',
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(getChartCostSummaryDetails.pending), (state) => {
      state.summaryChartLoader = true
    })
    builder.addMatcher(isAnyOf(getChartCostSummaryDetails.fulfilled), (state, action) => {
      state.summaryChartLoader = false
      state.summaryChart_state = action.payload
      state.summaryChartError = ''
    })
    builder.addMatcher(isAnyOf(getChartCostSummaryDetails.rejected), (state, action) => {
      state.summaryChartLoader = false
      state.summaryChartError = action.payload
    })
  },
  reducers: {
    emptysummaryChartSlice: (state) => {
      state.summaryChartLoader = false
      state.summaryChartError = ''
      state.summaryChart_state = []
    },
  },
})

export const { emptysummaryChartSlice } = summaryChartSlice.actions

export default summaryChartSlice.reducer
